import React from "react";
import "../designcss/Audiencewhatwedo.css";

const Audiencewhatwedocard = () => {
  return (
    <>
      <section className="what-we-do-wrapper">
        <div className="whatwedoaudience">
          <h1 className="audiencetitle">
            How to Target Audience Across Industries
          </h1>

          <p className="audiencepara">
            Audience targeting works for businesses of all sizes and sectors.
            With WoSender, campaigns can be tailored to industry-specific
            requirements and customer behavior to maximize impact.
          </p>

          <div className="cards-audience">
            <div className="info-audience">
              <h3>Industry-Specific Segmentation</h3>
              <p>
                WhatsApp marketing enables businesses to segment audiences based
                on behavior, interests, and buying intent. E-commerce brands can
                target repeat customers, cart abandoners, and seasonal shoppers
                effectively. This targeted approach ensures messages reach the
                right audience at the right time.
              </p>
            </div>

            <div className="info-audience">
              <h3>Personalized and Relevant Communication</h3>
              <p>
                Effective segmentation ensures messages are meaningful.
                Addressing customers by name, preferences, or past interactions
                creates natural, engaging conversations that build trust and
                loyalty without overwhelming users.
              </p>
            </div>

            <div className="info-audience">
              <h3>Best Practices for Smarter Targeting</h3>
              <p>
                Successful campaigns rely on permission-based messaging,
                controlled message frequency, and continuous optimization.
                Following WhatsApp policies and regularly analyzing performance
                improves delivery, response rates, and long-term compliance.
              </p>
            </div>

            <div className="info-audience">
              <h3>Real-Time Insights & Campaign Optimization</h3>
              <p>
                WoSender provides real-time tracking of audience performance,
                helping businesses refine targeting strategies and improve
                campaign effectiveness for higher engagement and stronger ROI.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Audiencewhatwedocard;
